import {AlertType} from "../../interfaces/IAlert";
<template>
  <v-card class="zone-modal">
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text v-if="editingZone && branch">
      <v-form @submit.prevent v-model="valid">
        <v-text-field
          :label="$t('name')"
          v-model="editingZone.name"
          :rules="$rule('required|min3|max128')"
          outlined
          dense
        ></v-text-field>
        <p class="mb-0 font-weight-medium">
          Haga clicks en el mapa para dibujar los puntos del area de envío.
          Mínimo 3 puntos.
        </p>
        <div
          class="mt-2"
          style="height: 350px; width: 100%; position: relative"
        >
          <l-map ref="myMap" @click="onMapClick" :zoom="15" :center="mapCenter">
            <l-tile-layer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <l-marker :lat-lng="mapCenter" />
            <l-polygon :lat-lngs="coordinates"></l-polygon>
          </l-map>
          <v-btn color="info" small class="reset" @click="reset" depressed
            ><v-icon small class="mr-1">mdi-delete</v-icon>Empezar de
            nuevo</v-btn
          >
        </div>
      </v-form @submit.prevent>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn text v-if="zone" @click="remove" color="red"
        ><v-icon>mdi-delete</v-icon> {{ $t('delete') }}</v-btn
      >
      <v-btn text @click="cancel">{{ $t('cancel') }}</v-btn>
      <v-btn color="primary" @click="save">{{ $t('save') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
  import { Component, Prop, Vue } from 'vue-property-decorator';
  import { vueData } from '../../VueData';
  import { AlertType } from '../../interfaces/IAlert';
  import ConfirmModal from './ConfirmModal.vue';
  import { IRestaurant } from '../../interfaces/IRestaurant';
  import { IDeliveryZone } from '../../interfaces/IDeliveryZone';
  import { IBranch } from '../../interfaces/IBranch';

  @Component
  export default class NewZoneModal extends Vue {
    $refs: {
      myMap: any;
    };
    @Prop() restaurant: IRestaurant;
    @Prop() branch: IBranch;
    @Prop() zone: IDeliveryZone;
    editingZone: IDeliveryZone = null;
    title = '';
    valid = false;
    coordinates: { lat: number; lng: number }[] = [];

    async created() {
      this.title = !this.zone ? 'Nueva zona' : `Editando ${this.zone.name}`;

      if (this.zone) {
        this.editingZone = { ...this.zone };
        for (let i = 0; i < this.zone.points.length; i += 2) {
          this.coordinates.push({
            lat: this.zone.points[i],
            lng: this.zone.points[i + 1],
          });
        }
      } else {
        this.editingZone = {
          restaurantId: this.restaurant.id,
          branchId: this.branch.id,
          name: null,
          points: [],
        } as IDeliveryZone;
      }
    }

    mounted() {
      if (this.$refs.myMap) {
        setTimeout(() => {
          this.$refs.myMap.mapObject.invalidateSize();
        }, 10);
      }
    }

    onMapClick(event) {
      this.coordinates.push(event.latlng);
    }

    get mapCenter() {
      return {
        lat: this.branch.lat,
        lng: this.branch.lon,
      };
    }

    reset() {
      this.coordinates = [];
    }

    async save() {
      if (!this.valid) {
        vueData.addAlert('Ingrese todos los datos necesarios', AlertType.Error);
        return;
      }
      if (this.coordinates.length < 3) {
        vueData.addAlert('Debe ingresar al menos 3 puntos', AlertType.Error);
        return;
      }
      if (this.coordinates.length > 20) {
        vueData.addAlert(
          'Debe ingresar como máximo 20 puntos',
          AlertType.Error
        );
        return;
      }
      this.editingZone.points = [];
      this.coordinates.forEach((c) => {
        this.editingZone.points.push(c.lat);
        this.editingZone.points.push(c.lng);
      });
      this.$parent.$emit('save', this.editingZone);
      this.$emit('close');
    }

    cancel() {
      this.$emit('close');
    }

    async remove() {
      this.$modal.show(
        ConfirmModal,
        {
          title: this.$t('delete.title', { name: this.zone.name }),
          message: this.$t('delete.warning'),
        },
        {
          name: 'delete',
          adaptive: true,
          height: 'auto',
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
          width: 600,
          clickToClose: false,
        },
        {
          confirm: async () => {
            this.$modal.hide('delete');
            this.$parent.$emit('delete');
            this.$emit('close');
          },
        }
      );
    }
  }
</script>
